module.exports = __webpack_public_path__ + "static/media/vtex6.a6ed6e75.png";